import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useState } from "react";
import CreateSongsModal from "../Components/CommanModals/CreateSongsModal";
import { useDispatch, useSelector } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { deleteLocation, editLocation, getLocations } from "../Redux/Actions/songs";
import NoData from "../Components/NoData";
import { capitalize } from "../Utils/commonFiles";
import DeleteModal from "../Components/CommanModals/DeleteModal";
import { toast } from "react-toastify";
import CreateLocationModal from "../Components/CommanModals/CreateLocationModal";

export default function Location() {
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [locationToDelete, setLocationToDelete] = useState(null);
    const [ischeckToggle, setIsCheckToggle] = useState({})

    const locationList = useSelector((e) => e.songAuth.locationList)

    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false);
        setSelectedLocation(null)
    }

    const handleOpenDeleteModal = (id) => {
        setLocationToDelete(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleDeleteSong = () => {
        dispatch(deleteLocation({ id: locationToDelete })).then((res) => {
            if (res?.payload?.statusCode == 200) {
                Initialize()
                toast.success("Deleted Successfully")
            } else {
                toast.error(res?.payload?.message)
            }
            handleCloseDeleteModal();
        })
    }

    useEffect(() => {
        if (locationList?.length > 0) {
            setIsCheckToggle(
                locationList.reduce((acc, item) => {
                    acc[item._id] = item.hasOwnProperty("active") ? item.active : true;
                    return acc;
                }, {})
            );
        }
    }, [locationList]);


    const handleChange = async (values) => {

        let data = {
            id: values._id,
            active: !values.active,
        };

        setIsCheckToggle((prevState) => ({
            ...prevState,
            [values._id]: !prevState[values._id],
        }));
        try {
            await dispatch(editLocation(data)).then((res) => {
                if (res?.payload?.statusCode == 200) {
                    Initialize()
                }
            })
        } catch (error) {
        }
    }

    const Initialize = () => {
        dispatch(startstopLoading(true));
        dispatch(getLocations()).then((res) => {
            dispatch(startstopLoading(false));
        });
    }

    useEffect(() => {
        Initialize()
    }, [dispatch]);

    return (
        <Layout>
            <Container fluid>
                <div className="comn-table-title">
                    <h3>
                        Locations <span>({locationList?.length ?? "0"})</span>
                    </h3>
                    <button onClick={handleShow}>Add Location</button>
                </div>
                <div className="filters">
                    <div className="inner-filter-field">
                        <div class="table-responsive">
                            <Table size="sm" className="table-cmn">
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="user-checkbox">Location Name</div>
                                        </th>
                                        <th>Visible</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {locationList?.length > 0 && locationList?.map((item, i) => (
                                        <tr key={i}>
                                            <td>
                                                <div className="first-user">
                                                    <div className="user-profile">
                                                        {capitalize(item?.name)}
                                                        {item?.cityName ? ` - ${capitalize(item.cityName)}` : ''}
                                                    </div>

                                                </div>
                                            </td>
                                            <td>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={ischeckToggle[item?._id] === true}
                                                        onChange={() => handleChange(item)}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </td>

                                            <td>
                                                <div className="d-flex gap-2">
                                                    <div className="td-txt-bg" onClick={() => {
                                                        handleOpenDeleteModal(item._id)
                                                    }} style={{ cursor: "pointer" }}>Delete</div>
                                                </div>
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <div className="mb-0">
                    <p className="pb-4"></p>
                </div>
            </Container>

            <CreateLocationModal show={showModal} handleClose={handleClose} selectedLocation={selectedLocation} Initialize={Initialize} />

            <DeleteModal
                show={showDeleteModal}
                handleClose={handleCloseDeleteModal}
                handleDelete={handleDeleteSong}
                name={"Location"}
            />
        </Layout>
    );
}
